import * as types from "../actions/actionTypes";

const initialState = {
  reviews: [],
  review: null,
};

const review = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_ALL_REVIEW_RESPONSE: return { ...state, reviews: action.payload };
    case types.GET_REVIEW_RESPONSE: return { ...state, reviews: action.payload };
    case types.GET_REVIEW_RESPONSE: return { ...state, reviews: action.payload };
    case types.GET_REVIEW_RESPONSE: return { ...state, reviews: action.payload };

    case types.CREATE_REVIEW: return { ...state, review: null };
    case types.UPDATE_REVIEW: return { ...state, review: null };
    case types.DELETE_REVIEW: return { ...state, review: null };
    default:
      return state;
  }
};

export default review;
